/* eslXXint-disable */
import { normalizeDiacriticsAndCase } from '../../../core/utils';

export default {
  transform: (chunk, { Types, Promise, Mappers, Logger, ServiceFactory }) =>
    new Promise(resolve => {
      const salonMapper = Mappers('salon');
      let distributorMongoId = null;
      const queryBuilderCache = {
        salons: {},
        addressesNeedingGeocode: [],
        refByDist: {},
      };
      chunk.forEach(obj => {
        if (distributorMongoId == null) {
          distributorMongoId = new Types.ObjectId(obj.__tmp.dist_id); //eslint-disable-line
        }
        // query to bulk lookup addresses that alreayd have geocoding
        queryBuilderCache.salons[obj.__tmp.ext_id] = {
          'ref.ext_id': obj.__tmp.ext_id,
        };
        // push all address to array and then remove if already geocoded down below
        queryBuilderCache.addressesNeedingGeocode.push({
          input_id: obj.__tmp.ext_id,
          ...obj.address,
        });
      });

      const salonExtIDQueryFragment = Object.keys(queryBuilderCache.salons).map(
        key => queryBuilderCache.salons[key],
      );
      const salonQuery = {
        $and: [
          { 'ref.distributor': distributorMongoId },
          { $or: salonExtIDQueryFragment },
          // { 'address.unique_id': { $exists: true } },
          // { 'address.unique_id': { $ne: null } },
        ],
      };

      salonMapper
        .find(salonQuery)
        .lean()
        .select('_id ref')
        .exec()
        .then(salons => {
          // remove each one of these from the array to geocode salon address because already geocoded
          salons.forEach(salon => {
            const ref = salon.ref.find(
              ref2 =>
                ref2.distributor.toString() === distributorMongoId.toString(),
            );
            const hasUniqueAddressId = (salon.address || {}).unique_id != null;
            queryBuilderCache.refByDist[`${ref.distributor}-${ref.ext_id}`] =
              salon.ref;
            queryBuilderCache.addressesNeedingGeocode = queryBuilderCache.addressesNeedingGeocode.filter(
              obj => obj.input_id === (ref || {}).ext_id && hasUniqueAddressId,
            );
          });
          // start disable address geocoding
          // const geocodeService = new ServiceFactory('geocode', []);
          // const promises = queryBuilderCache.addressesNeedingGeocode.map(adr =>
          //   geocodeService.sanitize([adr]),
          // );
          // return Promise.all(promises);
          return [];
          // end disable address geocoding
        })
        .then(geocodedAddresses => {
          const geocodedAddressesFormatted = [];
          geocodedAddresses.forEach(geocodedAddress => {
            if (geocodedAddress) {
              geocodedAddress.forEach(geocodedAddress2 => {
                if (geocodedAddress2) {
                  geocodedAddressesFormatted.push(geocodedAddress2);
                }
              });
            }
          });
          const newChunk = chunk.map(obj => {
            const newObject = { ...obj };
            if (!newObject.$set) {
              newObject.$set = {};
            }
            newObject.$set.dm = new Date();

            if (!newObject.$setOnInsert) {
              newObject.$setOnInsert = {};
            }
            newObject.$setOnInsert.status = 'approved';
            newObject.$setOnInsert.e = true;

            newObject.$setOnInsert.dc = new Date();

            if (newObject.$setOnInsert.n) {
              newObject.$setOnInsert.n_text = normalizeDiacriticsAndCase(
                newObject.$setOnInsert.n,
              );
            }

            // if (!newObject.$addToSet) {
            //   newObject.$addToSet = {};
            // }

            // cleanup ref
            const newRef =
              queryBuilderCache.refByDist[
                `${distributorMongoId}-${newObject.__tmp.ext_id}`
              ] || [];
            // add new value and remove later on if duplicate
            newRef.push({
              distributor: new Types.ObjectId(newObject.__tmp.dist_id),   //eslint-disable-line
              ext_id: newObject.__tmp.ext_id,  //eslint-disable-line
            });

            const groupedRef = newRef.reduce((r, a) => {
              // eslint-disable-next-line no-param-reassign
              const key = `${a.distributor}-${a.ext_id}`;
              // eslint-disable-next-line no-param-reassign
              r[key] = r[key] || [];
              r[key].push(a);
              return r;
            }, Object.create(null));
            const cleanRef = Object.keys(groupedRef).map(itmKey =>
              groupedRef[itmKey].reduce((a, b) =>
                a.last_sale <= b.last_sale || a.last_sale == null ? b : a,
              ),
            );
            console.info({ newRef, groupedRef, cleanRef });
            newObject.$set.ref = cleanRef;
            newObject.$noop = {
              ref: {
                distributor: new Types.ObjectId(newObject.__tmp.dist_id),   //eslint-disable-line
                ext_id: newObject.__tmp.ext_id,  //eslint-disable-line
              },
            };

            // check if in need of geocode
            const alerts = newObject.$set.alerts || [];

            // then check if it had positive geocode value
            const geocodedAddress = geocodedAddressesFormatted.find(
              add => add.input_id === newObject.__tmp.ext_id,
            );

            if (geocodedAddress) {
              delete geocodedAddress.input_id;
              newObject.$set.address = geocodedAddress;
            } else {
              newObject.$set.address = { ...newObject.address };
              alerts.push({
                code: 'address-invalid',
                level: 'warning',
              });
            }

            newObject.$set.alerts = alerts;
            delete newObject.address;
            delete newObject.__tmp;  //eslint-disable-line
            // console.info('newObject', newObject);
            return newObject;
          });
          // console.dir(newChunk, { depth: 999 });

          return resolve({ chunk: newChunk });
        });
    }),
};



// WEBPACK FOOTER //
// ./src/configs/etl/salons/salonsPayloadTransform.js